import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { retry } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  clientId = localStorage.getItem('selectedClientId') || null;

  constructor(private http: HttpClient) { }
  getDocuments(body, is_export: boolean = false) {
    {
      if (is_export) {
        return this.http.post(environment.baseApiUrl + `extraction/v1/list`, body, { observe: 'response', responseType: 'blob' });
      } else {
        return this.http.post(environment.baseApiUrl + `extraction/v1/list`, body);
      }
    }
  }

  getVersionDocuments(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/document/parent-retrieve', body)
  }
  
  // upload document
  uploadDocument(body: {}) {
    return this.http.post(environment.baseApiUrl + `extraction/v1/upload?client_id=${this.clientId} `, body);
  }

   uploadExcelDocument(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/shipments/create/excel?client_id=${this.clientId} `, body);
  }

  lockDocument(body: {}, id) {
    return this.http.patch(environment.baseApiUrl + `extraction/v1/document/edit/lock/${id}?client_id=${this.clientId}`, body)
  }

  updateDocumentData(body: {}) {
    return this.http.post(environment.baseApiUrl + `extraction/v1/document/action`, body);
  }
  getDocumentView(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/file/${document_id}?client_id=${this.clientId}`);
  }
  getDocumentTimeline(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/extracted-data/document-timeline-status/${document_id}?client_id=${this.clientId}`);
  }
  getDocumentOverview(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/detail/${document_id}?client_id=${this.clientId}`);
  }
  getValidationErrorDetails(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/document-errors/${document_id}?client_id=${this.clientId}`);
  }
  getDocumentLineDetails(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/extracted_data/document_line_items/${document_id}?client_id=${this.clientId}`);
  }
  getDocumentSummary(document_id) {
    return this.http.get(environment.baseApiUrl + `extraction/v1/extracted_data/document_summary/${document_id}?client_id=${this.clientId}`);
  }
  shareDocumentUrl(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/share/url', body);
  }
  addComment(body: {}) {
    return this.http.post(environment.baseApiUrl + 'tracker_email/comment', body);
  }
  onApproveReject(body: {}) {
    return this.http.post(environment.baseApiUrl + 'extraction/v1/document/status-update', body);
  }
  approveDocument(body: {}) {
    return this.http.post(environment.baseApiUrl + 'extraction/v1/extracted-data/approve-line-items', body);
  }
  rejectDocument(body: {}) {
    return this.http.post(environment.baseApiUrl + 'extraction/v1/extracted-data/reject-line-items', body);
  }
  deleteDocument(body: {}) {
    return this.http.post(environment.baseApiUrl + 'document/v1/share/url', body);
  }
  approveRejectFun(body:any){
    return this.http.post(environment.baseApiUrl + 'extraction/v1/document/status-update', body);
  }
  saveLineItemtFun(body:any,line_item_id:number){
    return this.http.put(environment.baseApiUrl + `extraction/v1/extracted_data/update/document-line-item/${line_item_id}?client_id=${this.clientId}`, body);
  }
  assignDocument(body:{}){
    return this.http.post(environment.baseApiUrl + `extraction/v1/assign-to-internal-user`, body)
  }
  reassignDocument(body:{}){
    return this.http.post(environment.baseApiUrl + `extraction/v1/reassign-document`, body)
  }
  revertAssignee(body:{}){
    return this.http.post(environment.baseApiUrl + `extraction/v1/assign-document/revert`, body)
  }
  getAllSupportingDocuments(body:{}){
    return this.http.post(environment.baseApiUrl + `extraction/v1/supporting-document/list-and-download`, body)
  }
  removeSupportingDocument(supporting_doc_id: string){
    return this.http.delete(environment.baseApiUrl + `extraction/v1/supporting-document/delete/${this.clientId}/${supporting_doc_id}`)
  }

  getCountAsPerStatus(){
    return this.http.post(environment.baseApiUrl + "extraction/v1/status-count",{client_id: this.clientId})
  }

  getValidationOrAuditErrors(body:{document_id: string}){
    return this.http.post(environment.baseApiUrl + "extraction/v1/document-validation-audit-errors", {client_id:this.clientId, document_id: body.document_id})
  }

  // getValidationErrors(body:{document_id: string}){
  //   return this.http.post(environment.baseApiUrl + "extraction/v1/document-audit-errors", {client_id:this.clientId, document_id: body.document_id})
  // }
  getInfomationRateCard(body){
    return this.http.post(environment.baseApiUrl + "master/v1/shipment_rate_surcharge_info", body)
  }
  
}
